import { render, staticRenderFns } from "./BelafspraakLink.vue?vue&type=template&id=76295bcc&"
import script from "./BelafspraakLink.vue?vue&type=script&lang=js&"
export * from "./BelafspraakLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports